import { createSlice } from '@reduxjs/toolkit';
const savedUrls = JSON.parse(localStorage.getItem('savedUrls')) || {name: '', url: '',camera_id:''};

const initialState = {
    rtspUrlSlice: savedUrls// Each item: { name: '', url: '' }
};

const rtspUrlSlice = createSlice({
  name: 'rtspUrlSlice',
  initialState,
  reducers: {
    addUrl: (state, action) => {
      const { name, url,camera_id,type } = action.payload;
      state.rtspUrlSlice={ name, url,camera_id,type };
      localStorage.setItem('savedUrls', JSON.stringify(state.rtspUrlSlice));
    },
   
   
    clearUrl: (state) => {
      state.rtspUrlSlice ={name: '', url: '',camera_id:''};
      localStorage.setItem('savedUrls', JSON.stringify(state.rtspUrlSlice));
    }
  }
});

export const { addUrl,clearUrl } = rtspUrlSlice.actions;

export default rtspUrlSlice.reducer;
